<template>
    <b-container>
        <b-row>
            <b-col xs="12">
                <b-form-group
                    label-for="name"
                    label="<strong>Nombre *</strong>"
                    :horizontal="true">
                    <b-form-input
                        id="name"
                        type="text"
                        placeholder="Nombre"
                        v-model="feeType.name">
                    </b-form-input>
                </b-form-group>
            </b-col>
        </b-row>

        <b-row>
            <b-col xs="12">
                <b-form-group
                    label-for="amount"
                    label="<strong>Cantidad *</strong>"
                    :horizontal="true">
                    <b-form-input
                        id="amount"
                        type="number"
                        placeholder="Cantidad"
                        v-model="feeType.amount">
                    </b-form-input>
                </b-form-group>
            </b-col>
        </b-row>

        <b-row>
            <b-col xs="12">
                <b-form-group
                    label-for="periodicity"
                    label="<strong>Periodicidad *</strong>"
                    :horizontal="true">
                    <periodicity-months-selector
                        id="periodicity"
                        v-model="feeType.periodicityMonths"></periodicity-months-selector>
                </b-form-group>
            </b-col>
        </b-row>

        <b-row v-if="!!showActive">
            <b-col xs="12" class="text-right">
                <b-form-checkbox
                    type="checkbox"
                    stacked
                    v-model="feeType.active"
                    name="hide">Activo
                </b-form-checkbox>
            </b-col>
        </b-row>

        <b-row class="mt-4">
            <b-col xs="12" class="d-flex flex-row-reverse">
                <button
                    class="btn btn-brand btn-primary btn-lg"
                    :disabled="!formValid"
                    @click="submitFeeType">
                    Guardar
                </button>
            </b-col>
        </b-row>
    </b-container>
</template>

<script>
    import periodicityMonthsSelector from '@/components/periodicity/PeriodicityMonthsSelector';

    export default {
        name: "FeeTypeForm",
        components: {
            periodicityMonthsSelector
        },
        props: {
            initialName: String,
            initialAmount: Number,
            initialPeriodicityMonths: Number,
            initialActive: Boolean,
            showActive: Boolean,
        },
        data: function () {
            return {
                feeType: {
                    name: this.initialName,
                    amount: this.initialAmount,
                    periodicityMonths: this.initialPeriodicityMonths,
                    active: this.initialActive
                }
            };
        },
        computed: {
            formValid() {
                return (
                    !!this.feeType.name
                    && !!this.feeType.amount
                    && !!this.feeType.periodicityMonths
                );
            }
        },
        methods: {
            submitFeeType() {
                this.$emit('submit-fee-type', this.feeType);
            }
        }
    }
</script>

<style scoped>

</style>